
import default1 from '../../Assets/defaultAvatars/defaultPic1.svg'
import default2 from '../../Assets/defaultAvatars/defaultPic2.svg'
import default3 from '../../Assets/defaultAvatars/defaultPic3.svg'

const pics = [default1, default2, default3]

export const returnDefaultPic = (idx) => pics[Math.round(idx > 3 ? idx / 3 : idx)]